import React from "react";
import { useLocation } from "react-router";

export function useQueryString() {
  const { search } = useLocation();
  const urlSearchParams = React.useMemo(() => new URLSearchParams(search), [search]);
  return urlSearchParams;
}
